module.exports = __webpack_public_path__ + "img/icon_money.d98763dc.svg";